// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

// get icon by name from public folder
const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: <Iconify icon="la:user" />,
  admin: <Iconify icon="la:shield-alt" />,
  store: <Iconify icon="bi:cart2" />,
  guide: <Iconify icon="iconoir:headset-help" />,
  mystic: <Iconify icon="line-md:sunny-outline-to-moon-alt-loop-transition" />,
  tools: <Iconify icon="fluent:square-hint-apps-20-regular" />,
  invoice: <Iconify icon="la:book-open" />,
  biopairs: <Iconify icon="la:bandcamp" />,
  dashboard: <Iconify icon="la:buffer" />
};

const optionsAdmin = [
  {
    title: 'admin',
    icon: ICONS.admin,
    path: PATH_DASHBOARD.admin.root,
    children: [
      { title: 'métricas', path: PATH_DASHBOARD.admin.metrics },
      { title: 'mapa del proyecto', path: PATH_DASHBOARD.admin.projectMap },
      { title: 'sendinblue', path: PATH_DASHBOARD.admin.sendinblue },
      { title: 'tarot', path: PATH_DASHBOARD.admin.tarot },
      { title: 'sueños', path: PATH_DASHBOARD.admin.suenos },
      { title: 'cartas astrales', path: PATH_DASHBOARD.admin.astralchart },
      { title: 'numerología', path: PATH_DASHBOARD.admin.numerologia },
      { title: 'runas', path: PATH_DASHBOARD.admin.runas },
      { title: 'carta nahual', path: PATH_DASHBOARD.admin.cartaNahual },
      { title: 'jobs', path: PATH_DASHBOARD.admin.jobs },
      { title: 'imageapproval', path: PATH_DASHBOARD.admin.imageapproval },
      { title: 'cortesias', path: PATH_DASHBOARD.admin.courtesies },
      { title: 'codigos de regalo', path: PATH_DASHBOARD.admin.giftCodes },
      { title: 'chats en vivo', path: PATH_DASHBOARD.admin.chatsEnVivo },
    ],
  },
]

export default function getNavConfig(isAdmin = false) {
  return ([
    // APPS
    // ----------------------------------------------------------------------
    {
      subheader: 'Apps',
      items: [
        // General
        { title: 'inicio', path: PATH_DASHBOARD.root, icon: ICONS.dashboard },

        // HERRAMIENTAS
        {
          title: 'Herramientas', path: PATH_DASHBOARD.tools.root, icon: ICONS.tools,
          children: [
            {
              title: 'Tarot', path: PATH_DASHBOARD.mystic.tarot.root,
              children: [
                { title: 'Una carta', path: PATH_DASHBOARD.mystic.tarot.single },
                { title: 'Tarot diario', path: PATH_DASHBOARD.mystic.tarot.daily },
                { title: 'Lectura profunda', path: PATH_DASHBOARD.mystic.tarot.ask },
                { title: 'Mis lecturas', path: PATH_DASHBOARD.mystic.tarot.history },
              ],
            },
            {
              title: 'Flores de Bach', path: PATH_DASHBOARD.tools.bachflowers.root,
              children: [
                { title: 'Consulta por grupo', path: PATH_DASHBOARD.tools.bachflowers.consulta },
                { title: 'Análisis completo', path: PATH_DASHBOARD.tools.bachflowers.completo },
              ],
            },
            {
              title: 'Chakras', path: PATH_DASHBOARD.tools.chakras.root,
              children: [
                { title: 'Test de Chakras', path: PATH_DASHBOARD.tools.chakras.consulta },
              ],
            },
            {
              title: 'Numerología', path: PATH_DASHBOARD.tools.numerology.root,
              children: [
                { title: 'Tu carta', path: PATH_DASHBOARD.tools.numerology.consulta },
                { title: 'Consulta a la medida', path: PATH_DASHBOARD.tools.numerology.consultaMedida },
                { title: 'El día de tu boda', path: PATH_DASHBOARD.tools.numerology.boda },
                { title: 'Mis lecturas', path: PATH_DASHBOARD.tools.numerology.lectura },
              ],
            },
            {
              title: 'Carta Astral', path: PATH_DASHBOARD.tools.astralchart.root,
              children: [
                { title: 'Consulta', path: PATH_DASHBOARD.tools.astralchart.consulta },
              ],
            },
            {
              title: 'Cristaloterapia', path: PATH_DASHBOARD.tools.crystals.root,
              children: [
                { title: 'Consulta', path: PATH_DASHBOARD.tools.crystals.consulta },
                { title: 'Biblioteca', path: PATH_DASHBOARD.biblioteca.crystals },
              ],
            },
            {
              title: 'Compatibilidad Astral', path: PATH_DASHBOARD.tools.sinastria.root,
              children: [
                { title: 'Consulta', path: PATH_DASHBOARD.tools.sinastria.consulta },
              ],
            },
            {
              title: 'Oráculo de Sueños', path: PATH_DASHBOARD.tools.suenos.root,
              children: [
                { title: 'Interpretación gratis', path: PATH_DASHBOARD.tools.suenos.consulta },
                { title: 'Lectura profunda', path: PATH_DASHBOARD.tools.suenos.profundo },
              ],
            },
            {
              title: 'Runas Nórdicas', path: PATH_DASHBOARD.tools.runas.root,
              children: [
                { title: 'Una runa gratis', path: PATH_DASHBOARD.tools.runas.consulta },
                { title: 'Tirada de las Nornas', path: PATH_DASHBOARD.tools.runas.tirada },
              ],
            },
            {
              title: 'Nahual Mexica', path: PATH_DASHBOARD.tools.nahual.root,
              children: [
                { title: 'Descubre tu nahual', path: PATH_DASHBOARD.tools.nahual.descubrir },
                { title: 'Carta Nahual', path: PATH_DASHBOARD.tools.nahual.carta },
              ],
            },
            {
              title: 'Quiromancia', path: PATH_DASHBOARD.tools.quiromancia.root,
              children: [
                { title: 'Lectura completa', path: PATH_DASHBOARD.tools.quiromancia.completa },
              ],
            },
            {
              title: 'Biopares', path: PATH_DASHBOARD.biopairs.root,
              children: [
                { title: 'Consulta', path: PATH_DASHBOARD.biopairs.root },
              ],
            },
          ],
        },

        // BIBLIOTECA
        {
          title: 'Biblioteca', path: PATH_DASHBOARD.biblioteca.root, icon: ICONS.invoice,
          children: [
            { title: 'Mis recursos', path: PATH_DASHBOARD.biblioteca.misRecursos },
            { title: 'Flores de Bach', path: PATH_DASHBOARD.biblioteca.bachflowers },
            { title: 'Chakras', path: PATH_DASHBOARD.biblioteca.chakras },
            { title: 'Numerología', path: PATH_DASHBOARD.biblioteca.numerology },
            { title: 'Planetas', path: PATH_DASHBOARD.biblioteca.planets },
          ],
        },
      ]
    },

    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: 'General',
      items: [
        // ADMIN
        ...(isAdmin ? optionsAdmin : []),

        // USER
        {
          title: 'usuario',
          icon: ICONS.user,
          path: PATH_DASHBOARD.user.root,
          children: [
            { title: 'perfil', path: PATH_DASHBOARD.user.account },
            { title: 'pagos', path: PATH_DASHBOARD.user.payments },
          ],
        },

        // STORE
        {
          title: 'tienda',
          path: PATH_DASHBOARD.store.root,
          icon: ICONS.store,
          children: [
            { title: 'mis compras', path: PATH_DASHBOARD.store.myOrders },
            { title: 'membresias', path: PATH_DASHBOARD.store.memberships },
          ],
        },

        // SUPPORT
        {
          title: 'soporte',
          path: PATH_DASHBOARD.support.guide,
          icon: ICONS.guide,
          children: [
            { title: 'guia', path: PATH_DASHBOARD.support.guide },
            { title: 'live chat', path: PATH_DASHBOARD.support.chat },
          ],
        },
      ]
    }
  ]);
}